import Fuse from "fuse.js";
import { Article } from "../types/article";

export const searchArrayOfArticles = (
    searchValue: string,
    articles: Article[]
) => {
    const fuse = new Fuse(articles, {
        threshold: 0.2,
        keys: ["id", "properties.name.en", "properties.name.th"],
    });
    const results = fuse.search(searchValue).map((result) => result.item);
    return results as Article[];
};
